export const MAX_QSEHRA_EMPLOYEES = 50
